import { useState } from "react";
import constate from "constate";

export const initStates = {
  showIncoming: true,
  showOutgoing: false,
  inConversation: true,
  inService: false,
  requestId: undefined,
  iqSessionId: undefined,
  callerNumber: undefined,
};

function _useCallStatus() {
  const [callStatusState, setCallStatusState] = useState(initStates);
  const [profileId, setProfileId] = useState<string | undefined>();
  const [phoneNumber, setPhoneNumber] = useState("");

  return {
    callStatusState,
    setCallStatusState,
    profileId,
    setProfileId,
    phoneNumber,
    setPhoneNumber,
  };
}

export const [CallStatusProvider, useCallStatus] = constate(_useCallStatus);
